import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14b5352c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-items-center tw-justify-between tw-gap-3 tw-w-full" }
const _hoisted_2 = { class: "tw-flex tw-flex-col tw-min-h-[50px] tw-justify-center" }
const _hoisted_3 = {
  key: 0,
  class: "tw-truncate page-topic-title tw-cursor-pointer",
  href: "https://help.cybersystem.io/"
}
const _hoisted_4 = { class: "tw-truncate page-topic-title" }
const _hoisted_5 = { class: "tw-truncate tw-whitespace-normal tw- page-topic-sub-description" }
const _hoisted_6 = {
  key: 0,
  class: "tw-truncate page-topic-title",
  href: "https://help.cybersystem.io/"
}
const _hoisted_7 = {
  key: 0,
  class: "tw-h-[38px] tw-w-[38px]"
}

import IconRight from "@/components/common/globalSearch/menuSearch/iconChevronRight.vue";
import { showErrorAPI } from "@/services/apiRoutes";
import { Subscription } from "@/services/apiRoutes/routes";
import { getSessionPortal } from "@/services/subscriptions";
import store from "@/store";
import { computed, ref } from "vue";
import ProgressAnimation from "../../../../assets/animation/progress_light.json";
import { LottieAnimation } from "lottie-web-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'pageTopic',
  props: {
    data: {}
  },
  emits: ["close-menu"],
  setup(__props: any, { emit }) {

const props = __props;

/** components */


const isLoadingStripURL = ref(false);

const getLatestChecklistId = computed(() => {
  return store.getters["Recommend/getLatestChecklistId"];
});

const routerSubscription = async () => {
  try {
    {
      isLoadingStripURL.value = true;
      const clientSecretResponse = await getSessionPortal("dashboard");
      const sessionPortalUrl =
        clientSecretResponse.data?.data?.redirectUrl || "";
      if (!sessionPortalUrl) {
        showErrorAPI("app-settings-subscription-error-text-1", "error");
        isLoadingStripURL.value = false;
        return;
      }
      window.location.href = sessionPortalUrl;
      setTimeout(() => {
        isLoadingStripURL.value = false;
      }, 1000);
      return;
    }
  } catch (error) {
    // showErrorAPI(error, Subscription.getSessionPortal);
  }
};



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.data.path === '/learn/help')
        ? (_openBlock(), _createElementBlock("a", _hoisted_3, _toDisplayString(_ctx.data.title), 1))
        : (_ctx.data.path === '/settings/subscription')
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              class: "tw-truncate page-topic-title tw-cursor-pointer",
              onClick: routerSubscription
            }, _toDisplayString(_ctx.data.title), 1))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: 2,
              to: 
          _ctx.data.path === '/assess/input'
            ? getLatestChecklistId.value !== undefined
              ? `${_ctx.data.path}?checklistId=${getLatestChecklistId.value}`
              : '/assess/manage'
            : _ctx.data.path
        ,
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('close-menu')), ["stop"]))
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.data.title), 1)
              ]),
              _: 1
            }, 8, ["to"])),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.data.description), 1)
    ]),
    (_ctx.data.path === '/learn/help')
      ? (_openBlock(), _createElementBlock("a", _hoisted_6, [
          _createVNode(IconRight)
        ]))
      : (_ctx.data.path === '/settings/subscription')
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            class: "tw-truncate page-topic-title tw-cursor-pointer",
            onClick: routerSubscription
          }, [
            (isLoadingStripURL.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_unref(LottieAnimation), {
                    ref: "anim",
                    "animation-data": _unref(ProgressAnimation),
                    "auto-play": true,
                    loop: true
                  }, null, 8, ["animation-data"])
                ]))
              : (_openBlock(), _createBlock(IconRight, { key: 1 }))
          ]))
        : (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            to: _ctx.data.path
          }, {
            default: _withCtx(() => [
              _createVNode(IconRight)
            ]),
            _: 1
          }, 8, ["to"]))
  ]))
}
}

})